__turbopack_context__.v({
  "cross": "IlluDotGrid-module__etcidG__cross",
  "dot": "IlluDotGrid-module__etcidG__dot",
  "grid": "IlluDotGrid-module__etcidG__grid",
});
